import { useEffect, useState } from "react";

import { Box, Typography } from "@mui/material";

import useLocalization from "../../hooks/useLocalization";
import useEntity from "../../hooks/useEntity";
import useData from "../../hooks/useData";

import Input from "../elements/Input";
import EditorToolbar from "./EditorToolbar";
import Switch from "../elements/Switch";

const BannerEditor = ({ bannerId, retailerId, onSave }) => {
  const { getLabel } = useLocalization();
  const { getFromServer } = useData();

  const [retailer, setRetailer] = useState([]);

  const {
    setEntity,
    emptyObject,
    entityData,
    clearEntityData,
    getEntityData,
    validateEntityData,
    updateField,
    message,
    isSuccessful,
    getFieldMessage,
    saved,
    setInitialValues,
  } = useEntity();

  useEffect(() => {
    setEntity("Banner", { retailerId });
    getRetailers();
  }, []);

  const getRetailers = async () => {
    const results = await getFromServer({
      entityName: "Retailer",
      id: retailerId,
    });

    if (results) {
      setRetailer(results);
    }
  };

  useEffect(() => {
    if (!bannerId) {
      clearEntityData();
    } else getEntityData(bannerId);
  }, [emptyObject]);

  const handleSave = async () => {
    validateEntityData();
  };

  useEffect(() => {
    if (!saved) return;
    onSave();
  }, [saved]);

  if (!entityData || !retailer) return;

  return (
    <Box
      width="100%"
      height="100%"
    >
      <EditorToolbar
        onSave={handleSave}
        message={message}
      />
      <Box
        width="calc(100% - 2rem)"
        height="calc(100% - 2rem - 30px)"
        padding="1rem"
        display="flex"
        flexDirection="column"
        gap={1}
        overflow="auto"
      >
        <Typography
          align="center"
          variant="h5"
        >
          {retailer.name}
        </Typography>
        <Input
          id="bannerName"
          label={getLabel("name")}
          value={entityData.name}
          onChange={(newValue) => updateField("name", newValue)}
          required
          fullwidth
          {...getFieldMessage("name")}
        />
        <Input
          id="bannerNameFr"
          label={getLabel("name_fr")}
          value={entityData.name_fr}
          onChange={(newValue) => updateField("name_fr", newValue)}
          fullwidth
          {...getFieldMessage("name_fr")}
        />
        <Switch
          label={getLabel("active")}
          value={!bannerId ? true : Boolean(entityData.isActive)}
          onChange={(newValue) => updateField("isActive", Boolean(newValue))}
        />
      </Box>
    </Box>
  );
};

export default BannerEditor;
